export function useUniqueId(prefix: string = ''): string {
    const id = useId();
    return `${prefix}${prefix ? '-' : ''}${id}`;
}
